// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

export class SpModalFilters {
  public operationalState?: SpModalFilter;
  public partStatus?: SpModalFilter;
  public ticketStatus?: SpModalFilter;
  public ticketType?: SpModalFilter;

  public constructor(obj?: Partial<SpModalFilters>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }

  public clone(): SpModalFilters {
    const clone = new SpModalFilters();
    if (this.operationalState) {
      clone.operationalState = this.operationalState.clone();
    }

    if (this.partStatus) {
      clone.partStatus = this.partStatus.clone();
    }

    if (this.ticketStatus) {
      clone.ticketStatus = this.ticketStatus.clone();
    }

    if (this.ticketType) {
      clone.ticketType = this.ticketType.clone();
    }

    return clone;
  }

  public merge(other: SpModalFilters): void {
    if (this.operationalState && other.operationalState) {
      this.operationalState.merge(other.operationalState);
    }

    if (this.partStatus && other.partStatus) {
      this.partStatus.merge(other.partStatus);
    }

    if (this.ticketStatus && other.ticketStatus) {
      this.ticketStatus.merge(other.ticketStatus);
    }

    if (this.ticketType && other.ticketType) {
      this.ticketType.merge(other.ticketType);
    }
  }

  public selectedValuesCount(): number {
    let result = 0;
    for (const property of Object.values(this)) {
      if (property.isSelected()) {
        result++;
      }
    }

    return result;
  }

  public clearAll(): void {
    for (const property of Object.values(this)) {
      property.selectedValue = 'All';
    }
  }
}

export class SpModalFilter {
  public constructor(
    public label: string = '',
    public options: string[] = [],
    public selectedValue: string = '',
  ) {}

  public clone(): SpModalFilter {
    return new SpModalFilter(
      this.label,
      this.options,
      String(this.selectedValue),
    );
  }

  public merge(other: SpModalFilter): void {
    this.selectedValue = other.selectedValue;
  }

  public isSelected(): boolean {
    return (
      this.selectedValue != null &&
      !['', 'all'].includes(this.selectedValue?.toLocaleLowerCase())
    );
  }
}
